<template>
	<el-dialog title="当日测量情况" :visible="visible" width="900px" class="home_measurement_dialog"
		:close-on-click-modal="false" :modal-append-to-body="true" :append-to-body="true" @close="closeDialog">
		
		<div style="min-height: 518px;">
			<el-table 
			:data="tableData"
			border
			:span-method="objectSpanMethod"
			class="measurement-table" 
			:key="Math.random()"
			:row-style="{
				height: '30px',
				padding: '6px 0',
				borderSpacing: 0,
				borderCollapse: 'collapse',
			}" 
			:row-class-name="changeTableRowColor"
			@cell-mouse-enter="handleCellMouseEnter"
			@cell-mouse-leave="handleCellMouseLeave"
			>
				<el-table-column label="床位名称" width="228">
					<template slot-scope="scope">
						<div style="text-align: justify;">
							{{ scope.row.bedName || '-' }}
						</div>
					</template>
				</el-table-column>
				<el-table-column label="时间" width="126" align="right">
					<template slot-scope="scope">
						<span>
							{{ scope.row.time || '-' }}
						</span>
					</template>
				</el-table-column>
				<el-table-column label="血氧(%)" width="126" align="right">
					<template slot-scope="scope">
						<span :class="{ 'text-red': scope.row.oxygenSaturationAbnormal === 1 }">
							{{ scope.row.oxygenSaturation || '-' }}
						</span>
					</template>
				</el-table-column>
				<el-table-column label="脉率(bpm)" width="126" align="right">
					<template slot-scope="scope">
						<span :class="{ 'text-red': scope.row.pulseRateAbnormal === 1 }">
							{{ scope.row.pulseRate || '-' }}
						</span>
					</template>
				</el-table-column>
				<el-table-column label="血压(mmHg)" width="126" align="right">
					<template slot-scope="scope">
						<span :class="{ 'text-red': scope.row.systolicBloodPressureAbnormal === 1 }">
							{{ scope.row.systolicBloodPressure || '-' }}
						</span>
						<span> / </span>
						<span :class="{ 'text-red': scope.row.diastolicBloodPressureAbnormal === 1 }">
							{{ scope.row.diastolicBloodPressure || '-' }}
						</span>
					</template>
				</el-table-column>
				<el-table-column label="体温(℃)" align="right">
					<template slot-scope="scope">
						<span :class="{ 'text-red': scope.row.bodyTemperatureAbnormal === 1 }">
							{{ scope.row.bodyTemperature || '-' }}
						</span>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<div class="home_measure_dialog_pagination_container">
			<a-pagination
				:defaultPageSize="pageSize"
				:current="currentPage"
				:default-current="currentPage"
				:total="total"
				@change="handleCurrentChange"
			/>
		</div>
	</el-dialog>
</template>

<script>
export default {
	name: "HomeMeasureDialog",
	props: {
		dialogVisible: {
			type: Boolean,
			default: false
		},
	},
	data() {
		return {
			currentPage: 1,
			pageSize: 10,
			visible: this.dialogVisible,
			model: null,
			dataList: null,
			tableData: [],
			total: 0,
			rowspan: 1,

			displayRowIndexes: [],
			mergeGroups: [],
			currentHoverGroup: [],
			hoverRowIndex: -1,
			isShowExtraColumns: true,
			// 新增：存储合并规则所需的数组（避免重复声明）
			bedNameSpans: [],
			getBedIdxSpans: [],
			currentBedName: "",
			sameBedNameCount: 0,
			extraSpans: []
		};
	},
	watch: {
		dialogVisible(newVal) {
			this.visible = newVal;
			if (newVal) {
				this.currentPage = 1;
				this.model = null;
				this.total = 0;
				this.getMeasureItemPage();
			}
		}
	},
	methods: {
		objectSpanMethod({ row, column, rowIndex, columnIndex }) {
			if (columnIndex === 0) {
				const currentBedName = row.bedName;
				let rowspan = 1;

				for (let i = rowIndex - 1; i >= 0; i--) {
					if (this.tableData[i].bedName === currentBedName) {
						return {
							rowspan: 0,
							colspan: 1
						};
					} else {
						break;
					}
				}

				for (let i = rowIndex + 1; i < this.tableData.length; i++) {
					if (this.tableData[i].bedName === currentBedName) {
						rowspan++;
					} else {
						break;
					}
				}

				return {
					rowspan: rowspan,
					colspan: 1
				};
			} else {
				return {
					rowspan: 1,
					colspan: 1
				};
			}
		},

		handleSizeChange(val) {
			this.pageSize = val;
			this.$emit('size-change', val);
		},

		handleSizeChange(val) {
			this.pageSize = val;
			this.getMeasureItemPage();
		},

		handleCurrentChange(val) {
			this.currentPage = val;
			this.getMeasureItemPage();
		},

		closeDialog() {
			this.$emit('update:dialogVisible', false);
		},

		getMeasureItemPage() {
			this.$get(
				'api/measure/measureSituationPage',
				{
					pageNum: this.currentPage,
					pageSize: this.pageSize
				},
				(res) => {
					if (res.code === 0) {
						if (res.data && res.data.measureRecordVoPage) {
							this.model = res.data;
							this.dataList = res.data.measureRecordVoPage.records || [];
							this.tableData = this.dataList;
							this.total = res.data.measureRecordVoPage.total || 0;
						} else {
							this.dataList = [];
							this.tableData = [];
							this.total = 0;
						}

						this.calculateSpanMethods(); // 触发合并计算
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					console.log(err);
				}
			);
		},

		changeTableRowColor({ row, rowIndex }) {
			if (this.currentHoverGroup.includes(rowIndex)) {
				return "merge-hover-row";
			}
			const displayIndex = this.displayRowIndexes.indexOf(rowIndex);
			if (displayIndex !== -1) {
				return displayIndex % 2 !== 0 ? "statistics-warning-row" : "";
			} else {
				let firstIndex = this.findNumber(this.displayRowIndexes, rowIndex);
				return this.displayRowIndexes.indexOf(firstIndex) % 2 !== 0 ? "statistics-warning-row" : "";
			}
		},

		handleCellMouseEnter(row) {
			const rowIndex = this.tableData.findIndex(
				item => item.bedId === row.bedId && item.statisticsDate === row.statisticsDate
			);
			if (rowIndex === -1) return;

			const targetGroup = this.mergeGroups.find(group => group.rows.includes(rowIndex));
			if (targetGroup) {
				this.currentHoverGroup = targetGroup.rows;
				this.hoverRowIndex = rowIndex;
			} else {
				this.currentHoverGroup = [rowIndex];
				this.hoverRowIndex = rowIndex;
			}
		},

		handleCellMouseLeave() {
			this.currentHoverGroup = [];
			this.hoverRowIndex = -1;
		},

		findNumber(arr, index) {
			return arr.reduce((result, num) => num <= index ? num : result, undefined);
		},

		// 计算“床位”和“上床时间”列的合并规则（原有逻辑保留）
		calculateSpanMethods() {
			this.bedNameSpans = [];
			this.getBedIdxSpans = [];
			// 新增：初始化「睡眠得分及之后列」的合并数组
			this.extraSpans = [];
			this.displayRowIndexes = [];
			this.currentBedName = "";
			this.sameBedNameCount = 0;
			this.mergeGroups = [];
			let currentGroup = null;

			this.tableData.forEach((row, index) => {
				if (row.bedName === this.currentBedName) {
					// 与上一行床位相同：延长所有需合并列的行数
					this.bedNameSpans[this.bedNameSpans.length - 1].rowspan += 1;
					this.bedNameSpans.push({ rowspan: 0, colspan: 0 });

					this.getBedIdxSpans[this.getBedIdxSpans.length - 1].rowspan += 1;
					this.getBedIdxSpans.push({ rowspan: 0, colspan: 0 });

					// 新增：同步延长「睡眠得分及之后列」的合并行数
					this.extraSpans[this.extraSpans.length - 1].rowspan += 1;
					this.extraSpans.push({ rowspan: 0, colspan: 0 });

					this.sameBedNameCount += 1;
					if (currentGroup) currentGroup.rows.push(index);
				} else {
					// 与上一行床位不同：重新初始化合并规则
					this.currentBedName = row.bedName;
					this.sameBedNameCount = 1;
					this.bedNameSpans.push({ rowspan: this.sameBedNameCount, colspan: 1 });
					this.getBedIdxSpans.push({ rowspan: this.sameBedNameCount, colspan: 1 });
					// 新增：初始化「睡眠得分及之后列」的合并规则（与床位列行数一致）
					this.extraSpans.push({ rowspan: this.sameBedNameCount, colspan: 1 });

					this.displayRowIndexes.push(index);
					currentGroup = { bedName: this.currentBedName, rows: [index] };
					this.mergeGroups.push(currentGroup);
				}
			});
		},
	},
};
</script>

<style lang="scss">
.home_measurement_dialog {

	.el-dialog__header {
		border-bottom: 1px solid rgba(0, 0, 0, 0.06);
	}

	.el-dialog__header .el-dialog__title {
		font-family: PingFangSC, "PingFang SC";
		font-weight: 500;
		font-size: 16px;
		color: #262626;
		line-height: 24px;
	}

	.measurement-table {
		width: 100%;
		margin-bottom: 20px;

		.el-table__header th {
			font-family: PingFangSC, "PingFang SC";
			font-weight: 600;
			font-size: 16px;
			color: #262626;
			line-height: 22px;
			background-color: rgba(243, 244, 247, 1);
		}

		.el-table__body td {
			font-family: PingFangSC, "PingFang SC";
			font-weight: 400;
			font-size: 16px;
			color: #262626;
			line-height: 22px;
		}

		// .el-table__body tr:nth-child(odd) {
		// 	background-color: red;
		// }

		// .el-table__body tr:nth-child(even) {
		// 	background-color: rgba(249, 250, 250, 1);
		// }

		// &,
		// .el-table__header-wrapper,
		// .el-table__header,
		// .el-table__body-wrapper,
		// .el-table__body,
		// th,
		// td {
		// 	border-color: rgba(232, 234, 237, 1);
		// }
	}

	.home_measure_dialog_pagination_container {
		text-align: center;
	}

	.text-red {
		color: rgba(255, 113, 134, 1) !important;
	}

	.statistics-warning-row {
		background: rgba(250, 250, 250, 1);
	}

	.el-table td {
		padding: 12px 0;
		background-clip: padding-box;
	}

	.el-table .cell {
		font-weight: normal;
	}

	.el-table--enable-row-transition .el-table__body td.el-table__cell {
		background: unset !important;
	}

	.merge-hover-row {
		background-color: rgba(246, 247, 250, 1) !important;
		transition: background-color 0.2s ease;
	}

	.el-dialog__body {
		padding-top: 20px;
	}

	.el-table th.el-table__cell>.cell {
		font-family: PingFangSC, PingFang SC;
		font-weight: 600;
		font-size: 16px;
		color: #262626;
		line-height: 22px;
	}

	.el-table .cell {
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		font-size: 16px;
		color: #262626;
		line-height: 22px;
	}
}
</style>